import { Vehicle } from "../Vehicle/Vehicle";

export class TripReport{


    constructor(private lineGroups:Array<ReportLineGroup>){

    }

    public getReport(){
        return this.lineGroups;
    }
}

export class ReportLine{

    tripId:string;
    status:string;
    UserId:number;
    PickupDay:string;
    PickupType:string;
    PickupHour:string;
    PickupTime:string;
    PickupLocation:string;
    VehicleMake:string;
    VehicleModel:string;
    VehicleYear:string;
    VehicleCapacity:string;
    Driver:string;
    Passenger:string;
    PassengerDropOffTime:string;
    PassengerDropOffTimeOnly:string;
    Distance:string;
    DistanceFromSource:string;
    Duration:string;
    Department:string;
    PassengerAddress:string;
    Rating:number = 1;

    constructor(){

    }
}

export class ReportLineGroup{

    constructor(private reportLines:Array<ReportLine>){

    }

    public getReportLines(){

        return this.reportLines;
    }
}




// WEBPACK FOOTER //
// ./src/app/DataStructures/TripReport/TripReport.ts